import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import "./app.css"
import "./component/fontawesome-free-5.15.4-web/css/all.css"
import "./component/fontawesome-free-5.15.4-web/css/all.min.css"
import LeftMenu from "./component/leftmenu/leftmenu";
import Abonentplata from "./component/pages/abonentplata/abonentplata";
import Zayavki from "./component/pages/zayavki/zayavki";
import Prixodrasxodgps from "./component/pages/prixodrasxodgps/prixodrasxodgps";
import Prixodrasxodmoney from "./component/pages/prixodrasxodmoney/prixodrasxodmoney";
import Reports from "./component/pages/reports/reports";
import Login from "./login";
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => !!localStorage.getItem("gps_token")
  );
  const [checked, setChecked] = useState("0");

  const handleLogin = () => setIsLoggedIn(true);
  const handleLogout = () => {
    localStorage.removeItem("gps_token");
    setIsLoggedIn(false);
  };

  const sentTelegram = ({ typeMoney, operation, source, name, summa }) => {
    const TOKEN = "8569753933:AAGll0qeCKC1vIoK3vyF97tOfZTfFB5z4_c";
    const CHAT_ID = "-1003315313254";
    const URI_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;
    const formattedSum = Number(summa).toLocaleString('ru-RU').replace(/\s/g, '.');
    let operationmes = operation === "Расход" ? "Расход🔴" : "Приход🟢";
    let mes = `<b></b>\n`;
    mes += `<b>💸Операция: </b>${operationmes}\n`;
    mes += `<b>💱Тип оплаты: </b>${typeMoney}\n`;
    mes += `<b>📊Источник: </b>${source}\n`;
    mes += `<b>🆔Наименование: </b>${name}\n`;
    mes += `<b>🤑Сумма: </b>${formattedSum} сум\n`;
    axios.post(URI_API, { chat_id: CHAT_ID, parse_mode: "HTML", text: mes }).catch(() => { });
  };

  if (!isLoggedIn) return <Login onLogin={handleLogin} />;

  return (
    <section className="app-screen">
      <LeftMenu checked={checked} setChecked={setChecked} onLogout={handleLogout} />
      <Routes>
        <Route path="/" element={<Abonentplata setChecked={setChecked} sentTelegram={sentTelegram} />} />
        <Route path="/Zayavki" element={<Zayavki setChecked={setChecked} />} />
        <Route path="/Prixodrasxodgps" element={<Prixodrasxodgps setChecked={setChecked} />} />
        <Route path="/Prixodrasxodmoney" element={<Prixodrasxodmoney setChecked={setChecked} sentTelegram={sentTelegram} />} />
        <Route path="/Reports" element={<Reports setChecked={setChecked} />} />
      </Routes>
    </section>
  );
};

export default App;
